"use client";

const desktopHeroImageUrl = "https://grateful-javelin.10web.cloud/wp-content/uploads/2026/04/fb-cover-NO-tools-scaled.jpg";
export default function BeyondTheMap() {
  return <section data-section-id="222783" id="performanță-fără-compromis" className="dark bg-background text-foreground relative min-h-[420px] md:min-h-[520px] xl:min-h-[650px] min-[1800px]:min-h-[750px] min-[2200px]:min-h-[900px] w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-[center_40%] bg-no-repeat" style={{
      backgroundImage: `url("${desktopHeroImageUrl}")`
    }} />
    </section>;
}